export function parseStates(states: string | string[] | undefined): string[] {
  if (!states) return []
  if (Array.isArray(states)) {
    return states.map((state) => state.trim()).filter(Boolean)
  }
  return String(states)
    .split(",")
    .map((state) => state.trim())
    .filter(Boolean)
}
